import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadDialingRatesBlockData from '../../../Models/Content/AbroadDialingRatesBlockData';
import {Col, Row, Container} from 'reactstrap';
import {connect} from 'react-redux';
import React, {useEffect, useState} from 'react';
import {gaEvent} from '../../../utilities/analytics/tracking';
import gaParams from '../../../utilities/analytics/constants';

const AbroadDialingRates = (props) => {
  let isBusiness = false;
  const search = 'עמוד תוצאות חיפוש';
  const lobby = 'עמוד לובי';

  const [url, setUrl] = useState('');

  useEffect(() => {
    if (props.generalData.abroadMarketPrice != undefined) setUrl(props.generalData.abroadMarketPrice.url);
  }, [props.generalData]);

  useEffect(() => {
    if (props.activeLobbyTab == 'businessAccount') isBusiness = true;

    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, []);

  useEffect(() => {
    if (props.activeLobbyTab == 'businessAccount') isBusiness = true;
    else isBusiness = false;

    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [props.activeLobbyTab, props.abroadPackagesList]);

  const gaReport = () => {
    if (props.otpData.validatedCostumerData?.isSeparatedSale) {
      gaEvent(
        gaParams.SEPARATED_TARIFFZONEBUTTON_CLICK.category,
        gaParams.SEPARATED_TARIFFZONEBUTTON_CLICK.eventType,
        props.abroadPackagesList ? search : lobby
      );
    } else {
      if (isBusiness) {
        gaEvent('hul_sale_business', 'click_35', props.abroadPackagesList ? search : lobby);
      } else {
        gaEvent('hul_sale_private', 'click_23', props.abroadPackagesList ? search : lobby);
      }
    }
  };

  function trackScrolling() {
    const wrappedElement = document.getElementById('abroad-dialing-rates');
    if (isBottom(wrappedElement)) {
      if (isBusiness) {
        if (props.otpData.validatedCostumerData?.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_TARIFFZONEBUTTON_SHOW.category,
            gaParams.SEPARATED_TARIFFZONEBUTTON_SHOW.eventType,
            props.abroadPackagesList ? search : lobby
          );
        } else {
          gaEvent('hul_sale_business', 'visibility_22', props.abroadPackagesList ? search : lobby);
        }
      } else {
        if (!props.businessIndividual) {
          gaEvent('hul_sale_private', 'visibility_14', props.abroadPackagesList ? search : lobby);
        }
      }

      window.removeEventListener('scroll', trackScrolling);
    }
  }

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  return (
    <div id='abroad-dialing-rates' className='abroad-dialing-rates'>
      <Container>
        <Row>
          <Col>
            <div>
              <h3>כמה זה יעלה</h3>
              <h3>
                <strong>בלי חבילת {window.Config.brand_Name_HE} חו"ל?</strong>
              </h3>
              {/* <h2>חיוב עבור שיחות יוצאות או נכנסות פר דקה או חלק ממנה</h2> */}
            </div>
          </Col>

          <Col>
            <div style={{textAlign: 'center'}} onClick={gaReport}>
              <a href={url}>
                <div className='bg-button'>
                  <div className='bg-button-first'>
                    <div className='bg-text'>
                      <span>
                        תעריפי שימוש בחו"ל <br />
                        ללא החבילה
                      </span>
                    </div>
                    <div className='bg-arrow'>
                      <div className='arrow-circle'>&#187;</div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    generalData: state.cellcomAbroad.getEpiGeneralData,
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    abroadPackagesList: state.cellcomAbroad.abroadPackagesList,
    otpData: state.cellcomAbroad.otpData,
    businessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
  };
};

export default connect(mapStateToProps)(AbroadDialingRates);
